<template>
  <v-card
    color="grey lighten-5"
    :to="item.to"
    class="d-flex flex-column item"
    height="100%"
    flat
  >
    <img
      :src="item.img + `?resize=1&w=600`"
      :alt="item.title"
      class="d-block item-img"
    />

    <div class="px-3 px-sm-4 py-4 py-sm-7">
      <div class="grey--text text--darken-1 d-flex mb-2" v-if="item.date">
        <v-icon
          color="grey lighten-3"
          :size="xs ? 14 : 16"
          class="align-baseline"
        >
          far fa-calendar
        </v-icon>

        <div class="text-body-2 ml-2">
          {{ formatDate(item.date, "long") }}
        </div>
      </div>

      <div
        class="
          text-caption text-md-body-1
          grey--text
          text--darken-4
          font-weight-bold
        "
      >
        <div class="item-title">
          {{ item.title }}
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatDate } from "../../utils/formatDate";
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    formatDate,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 16 / 12;
    border-radius: 4px 4px 0 0;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  .item-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
